import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const THEME = {
  accent: "#eefa94",
  surface: "#e9eeea",
  triggerOpen: "border-gray-400 ring-2 ring-gray-200",
  triggerIdle: "border-gray-300 hover:border-gray-400",
};

function ThemeRadio({ checked }) {
  return (
    <span
      className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
        checked ? "border-gray-900" : "border-gray-400"
      }`}
    >
      {checked && (
        <span className="w-2 h-2 rounded-full bg-gray-900" />
      )}
    </span>
  );
}

/**
 * Single-select time range filter — matches Templates page theme.
 */
export default function TemplateTimeRangeFilter({
  value = null,
  options = [],
  onChange,
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const selectedLabel =
    options.find((o) => o.id === value)?.label ||
    options.find((o) => o.id === null)?.label ||
    "All time";

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center justify-between gap-2 px-4 py-2.5 text-sm font-medium text-gray-900 border rounded-xl bg-white min-w-[140px] transition-all shadow-sm ${
          open ? THEME.triggerOpen : THEME.triggerIdle
        }`}
      >
        <span className="truncate">{selectedLabel}</span>
        <ChevronDown
          size={16}
          className={`text-gray-500 shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          className="absolute right-0 z-50 mt-2 min-w-[200px] bg-white border border-gray-200 rounded-2xl shadow-lg overflow-hidden py-1"
        >
          {options.map((opt) => {
            const checked = value === opt.id;
            return (
              <button
                key={String(opt.id)}
                type="button"
                onClick={() => {
                  onChange(opt.id);
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left transition-colors hover:bg-[#e9eeea]"
                style={
                  checked ? { backgroundColor: "rgba(238, 250, 148, 0.35)" } : undefined
                }
              >
                <ThemeRadio checked={checked} />
                <span className="text-gray-800">{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
